import React from 'react';
import "./style.scss";

export default function({value}) {
    return <p className='customLabel'>{value}</p>
} 